module.exports = __webpack_public_path__ + "static/img/urinary_organs.d03c90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/urinary_organs.png
// module id = vXmM
// module chunks = 1